import React from 'react';
import { Number } from '@tradingblock/components';
import { CashieringBaseEntity } from '@tradingblock/types';
import { CashieringEntityStatus } from '../../../../../components/cashiering/CashieringEntityStatus';
import {
  getFormattedTransferIRAContributionType,
  getFormattedTransferIRADistributionReason,
} from '../../../../../utilities/cashiering';

interface TransactionCellProps
  extends Pick<
    CashieringBaseEntity,
    'transfer' | 'status' | 'relationship' | 'transferRecipientBank' | 'transferWireInstruction'
  > {}

export const TransactionCell: React.FunctionComponent<TransactionCellProps> = ({
  relationship,
  status,
  transfer,
  transferRecipientBank,
  transferWireInstruction,
}) => {
  const isIRA = (transfer && transfer.iraContributionType) || (transfer && transfer.iraDistributionReason);

  const renderTransactionType = () => {
    if (relationship) {
      return (
        <div className="transaction-type">
          <div className="transaction-label">ACH relationship</div>
          <CashieringEntityStatus status={status} className="txt-sm" />
        </div>
      );
    }

    if (transferRecipientBank) {
      return (
        <div className="transaction-type">
          <span className="transaction-label">Transfer Recipient Bank Request</span>
          <CashieringEntityStatus status={status} className="txt-sm" />
        </div>
      );
    }

    if (transferWireInstruction) {
      return (
        <div className="transaction-type">
          <span className="transaction-label">Transfer Wire Instruction Request</span>
          <br />
          <CashieringEntityStatus status={status} className="txt-sm" />
        </div>
      );
    }

    if (transfer) {
      const getAmountDisplay = () => {
        if (transfer.amount === null) {
          if (
            transfer.disbursementType === 'FullBalance' ||
            transfer.disbursementType === 'FullBalanceAndCloseAccount'
          ) {
            return 'FULL BALANCE';
          }
          if (transfer.disbursementType === 'PartialBalance') {
            return 'PARTIAL BALANCE';
          }
          return '';
        }
        return <Number value={transfer.amount} currency={true} />;
      };

      const getDirectionLabel = () => {
        if (transfer.direction === 'Incoming') {
          return isIRA ? 'CONTRIBUTION' : 'DEPOSIT';
        }
        return isIRA ? 'DISTRIBUTION' : 'WITHDRAWAL';
      };

      const getIRADetails = () => {
        const details = [];
        if (transfer.iraContributionType) {
          details.push(getFormattedTransferIRAContributionType(transfer.iraContributionType));
        }
        if (transfer.iraDistributionReason) {
          details.push(getFormattedTransferIRADistributionReason(transfer.iraDistributionReason));
        }
        return details.join(' ');
      };

      return (
        <div className="transaction-type">
          <div className="transaction-amount">
            {getAmountDisplay()}
            {transfer.amount !== null && <span className="transaction-direction"> {getDirectionLabel()}</span>}
            {transfer.amount === null && <span className="transaction-direction"> {getDirectionLabel()}</span>}
          </div>
          {getIRADetails() && <div className="transaction-ira-details">{getIRADetails()}</div>}
          <CashieringEntityStatus status={status} className="txt-sm" />
        </div>
      );
    }

    return null;
  };

  return <div className="cashiering-transaction-cell">{renderTransactionType()}</div>;
};
